module.exports = {
  projectId: 'iesArroyoHondo_root',
  codeSpliting: true,
  runServiceWorker: true,
}
